import PropTypes from 'prop-types';
import React from "react";
import * as rmd from 'material-ui';
import auth from '../auth';
import config from 'cfg';
import { Link } from 'react-router';
import uc from '../styles/images/under_construction.png'
import tw from '../styles/images/tw.png'
import fb from '../styles/images/fb.png'
import et from '../styles/images/edit_theme.png'
import cw from '../styles/images/create_widget.png'
import suggested from '../styles/images/suggested.png'

import ContentAdd from 'material-ui/svg-icons/content/add';

class FAQ extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
        };
    }
    static contextTypes = {
        user: PropTypes.object.isRequired
    }
    render () {
        var user = this.context.user;
        var colors = ['#F4013C', '#F46E02', '#04A9F4'];
        return (
            <div className="home">
                <rmd.Subheader>
                    <div>Hi, {user.username}</div>
                </rmd.Subheader>
            </div>
        )
    }
}

export default FAQ;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/FAQ.js
 **/